/**
 * Subscription API client
 *
 * Handles Stripe subscription operations:
 * - Get subscription status
 * - Create checkout session
 * - Create billing portal session
 */

import { api } from './client'

// ============================================
// Types
// ============================================

export interface SubscriptionStatus {
  has_access: boolean
  is_grandfathered: boolean
  subscription_status: string | null
  subscription_price_id: string | null
  subscription_period_end: string | null
}

export interface SubscriptionPrices {
  monthly: string | null
  yearly: string | null
}

export interface CheckoutResponse {
  checkout_url: string
}

export interface PortalResponse {
  portal_url: string
}

// ============================================
// API Functions
// ============================================

/**
 * Get current subscription status
 */
export async function getSubscriptionStatus(): Promise<SubscriptionStatus> {
  return api.get<SubscriptionStatus>('/api/subscription/status')
}

/**
 * Get available subscription prices
 */
export async function getSubscriptionPrices(): Promise<SubscriptionPrices> {
  return api.get<SubscriptionPrices>('/api/subscription/prices')
}

/**
 * Create a Stripe checkout session
 * Returns URL to redirect user to Stripe checkout
 */
export async function createCheckout(priceId: string): Promise<CheckoutResponse> {
  return api.post<CheckoutResponse>('/api/subscription/checkout', { price_id: priceId })
}

/**
 * Create a Stripe billing portal session
 * Returns URL to redirect user to manage their subscription
 */
export async function createBillingPortal(): Promise<PortalResponse> {
  return api.post<PortalResponse>('/api/subscription/portal')
}
